import { BaseAPI } from 'API/BaseApi';
import { IOrderWorkflow } from 'types/order/workflow/IOrderWorkflow';

export const WorkflowApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listWorkflows: build.query<IOrderWorkflow[], { orderId: string }>({
        query: ({ orderId }) => ({
          url: `/timber/api/internal/orders/${orderId}/workflows`,
          method: 'GET',
        }),
      }),
  }),
});

export const { useListWorkflowsQuery } = WorkflowApi;